export const profits = {
  'backoffice.profits.accountsSummary.title': 'Kontogeninn-Zusammenfassung',
  'backoffice.profits.accountsSummary.subtitle': 'Überblick über die Gewinnleistung aller Ihrer Anlagekonten',
  'backoffice.profits.accountsHistory.title': 'Kontogeninn-Verlauf',
  'backoffice.profits.accountsHistory.subtitle': 'Detaillierte historische Gewinndaten Ihrer Anlagekonten',
  'backoffice.profits.commissionsSummary.title': 'Provisionen-Zusammenfassung',
  'backoffice.profits.commissionsSummary.subtitle': 'Überblick über Ihre Empfehlungsprovisionen und Einnahmen',
  'backoffice.profits.commissionsHistory.title': 'Provisionen-Verlauf',
  'backoffice.profits.commissionsHistory.subtitle': 'Detaillierter Verlauf der Provisionseinnahmen und Transaktionen',
  'backoffice.profits.commissionsPaymentHistory.title': 'Provisionszahlungs-Verlauf',
  'backoffice.profits.commissionsPaymentHistory.subtitle': 'Verfolgen Sie alle Provisionszahlungen und Auszahlungsverläufe',
  'backoffice.profits.common.loading': 'Gewinndaten werden geladen...',
  'backoffice.profits.common.error': 'Fehler beim Laden der Gewinninformationen',
  'backoffice.profits.common.noData': 'Keine Gewinndaten verfügbar',
  'backoffice.profits.common.comingSoon': 'Diese Funktion wird bald verfügbar sein',
  'backoffice.profits.common.placeholder': 'Gewinndetails werden hier angezeigt, sobald sie implementiert sind',
  'backoffice.profits.lifetime.title': 'Lebenszeit-Kontogeninne',
  'backoffice.profits.lifetime.totalProfit': 'Gesamter Lebenszeit-Gewinn',
  'backoffice.profits.lifetime.accountProfit': 'Kontogewinn',
  'backoffice.profits.lifetime.programProfit': 'Programmgewinn',
  'backoffice.profits.lastMonth.title': 'Kontogeninne des letzten Monats',
  'backoffice.profits.lastMonth.totalProfit': 'Gesamtgewinn des letzten Monats',
  'backoffice.profits.lastMonth.accountProfit': 'Kontogewinn',
  'backoffice.profits.lastMonth.programProfit': 'Programmgewinn',
  'backoffice.profits.overtime.title': 'Kontogeninne im Zeitverlauf',
  'backoffice.profits.overtime.chartTitle': 'Gewinnverlauf (Letzte 12 Monate)',
  'backoffice.profits.breakdown.title': 'Aufschlüsselung nach Konto',
  'backoffice.profits.breakdown.accountNumber': 'Kontonummer',
  'backoffice.profits.breakdown.broker': 'Broker',
  'backoffice.profits.breakdown.balance': 'Kontostand',
  'backoffice.profits.breakdown.accountProfit': 'Kontogewinn',
  'backoffice.profits.breakdown.programProfit': 'Programmgewinn',
  'backoffice.profits.breakdown.totalProfit': 'Gesamtgewinn',
  'backoffice.profits.breakdown.noAccounts': 'Keine Konten gefunden',
  'backoffice.profits.history.filters.account': 'Konto',
  'backoffice.profits.history.filters.allAccounts': 'Alle Konten',
  'backoffice.profits.history.filters.dateFrom': 'Von Datum',
  'backoffice.profits.history.filters.dateTo': 'Bis Datum',
  'backoffice.profits.history.filters.apply': 'Filter Anwenden',
  'backoffice.profits.history.filters.reset': 'Zurücksetzen',
  'backoffice.profits.history.table.title': 'Gewinnverlauf',
  'backoffice.profits.history.table.account': 'Konto',
  'backoffice.profits.history.table.period': 'Zeitraum',
  'backoffice.profits.history.table.accountProfit': 'Kontogewinn',
  'backoffice.profits.history.table.exportCSV': 'CSV Exportieren',
  'backoffice.profits.history.pagination.showing': 'Zeige',
  'backoffice.profits.history.pagination.of': 'von',
  'backoffice.profits.history.pagination.results': 'Ergebnissen',
  'backoffice.profits.history.pagination.page': 'Seite',
  'backoffice.profits.history.pagination.previous': 'Vorherige',
  'backoffice.profits.history.pagination.next': 'Nächste',
  'backoffice.profits.history.pagination.loadMore': 'Mehr Laden',
  'backoffice.profits.commissions.lifetime.title': 'Lebenszeit-Provisionen',
  'backoffice.profits.commissions.lastMonth.title': 'Provisionen des letzten Monats',
  'backoffice.profits.commissions.balance.title': 'Aktueller Saldo',
  'backoffice.profits.commissions.balance.lastUpdated': 'Zuletzt aktualisiert:',
  'backoffice.profits.commissions.paid.title': 'Gesamt Bezahlt',
  'backoffice.profits.commissions.overtime.title': 'Provisionen im Zeitverlauf',
  'backoffice.profits.commissionsHistory.filters.level': 'Ebene',
  'backoffice.profits.commissionsHistory.filters.allLevels': 'Alle Ebenen',
  'backoffice.profits.commissionsHistory.filters.levelNumber': 'Ebene {{level}}',
  'backoffice.profits.commissionsHistory.table.title': 'Provisionsverlauf',
  'backoffice.profits.commissionsHistory.table.date': 'Datum',
  'backoffice.profits.commissionsHistory.table.level': 'Ebene',
  'backoffice.profits.commissionsHistory.table.levelCompany': 'Unternehmen',
  'backoffice.profits.commissionsHistory.table.levelLeftover': 'Rest',
  'backoffice.profits.commissionsHistory.table.commission': 'Provision',
  'backoffice.profits.commissionsHistory.table.levelNumber': 'Ebene {{level}}',
  'backoffice.profits.commissionsPaymentHistory.filters.status': 'Status',
  'backoffice.profits.commissionsPaymentHistory.filters.allStatuses': 'Alle Status',
  'backoffice.profits.commissionsPaymentHistory.filters.paymentMethod': 'Zahlungsmethode',
  'backoffice.profits.commissionsPaymentHistory.filters.allPaymentMethods': 'Alle Zahlungsmethoden',
  'backoffice.profits.commissionsPaymentHistory.filters.crypto': 'Krypto',
  'backoffice.profits.commissionsPaymentHistory.filters.bank': 'Banküberweisung',
  'backoffice.profits.commissionsPaymentHistory.table.title': 'Provisionszahlungs-Verlauf',
  'backoffice.profits.commissionsPaymentHistory.table.date': 'Datum',
  'backoffice.profits.commissionsPaymentHistory.table.paymentMethod': 'Zahlungsmethode',
  'backoffice.profits.commissionsPaymentHistory.table.status': 'Status',
  'backoffice.profits.commissionsPaymentHistory.table.amount': 'Betrag',
  'backoffice.profits.commissionsPaymentHistory.table.exportCSV': 'CSV Exportieren',
  'backoffice.profits.commissionsPaymentHistory.status.paid': 'Bezahlt',
  'backoffice.profits.commissionsPaymentHistory.status.completed': 'Abgeschlossen',
  'backoffice.profits.commissionsPaymentHistory.status.pending': 'Ausstehend',
  'backoffice.profits.commissionsPaymentHistory.status.cancelled': 'Storniert',
  'backoffice.profits.commissionsPaymentHistory.status.failed': 'Fehlgeschlagen',
  'backoffice.profits.commissionsPaymentHistory.status.rejected': 'Abgelehnt',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.crypto': 'Krypto',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.bank': 'Banküberweisung',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.unknown': 'Unbekannt'
};
